var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAtAGlance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.04,
    height: 7.56
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.79,
    height: 7.56,
    rx: 0.78
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    width: 5.79,
    height: 7.56,
    rx: 0.78
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    width: 5.79,
    height: 7.56,
    rx: 0.78
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    width: 5.79,
    height: 7.56,
    rx: 0.78
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMi4wNCIgaGVpZ2h0PSI3LjU2IiB2aWV3Qm94PSIwIDAgMzIuMDQgNy41NiI+CiAgPGc+CiAgICA8cmVjdCB3aWR0aD0iNS43OSIgaGVpZ2h0PSI3LjU2IiByeD0iMC43OCIvPgogICAgPHJlY3QgeD0iOC43NSIgd2lkdGg9IjUuNzkiIGhlaWdodD0iNy41NiIgcng9IjAuNzgiLz4KICAgIDxyZWN0IHg9IjE3LjUiIHdpZHRoPSI1Ljc5IiBoZWlnaHQ9IjcuNTYiIHJ4PSIwLjc4Ii8+CiAgICA8cmVjdCB4PSIyNi4yNSIgd2lkdGg9IjUuNzkiIGhlaWdodD0iNy41NiIgcng9IjAuNzgiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgAtAGlance as ReactComponent };